import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
if(localStorage.getItem('token') === null || localStorage.getItem('token') == ""){
    let router = inject(Router);
    router.navigateByUrl('');
    return false;
  }
  else{
    return true;
  }};
